import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { isMobileWithOutIpad, LANGUAGE } from '@helpers/EnvHelper';
import { NAV_LIST } from '@helpers/NavHalper';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import Select from '@atoms/Select';
import HeaderMobile from './HeaderMobile';
import useShrink from '@hook/useShrink';

import '@assets/page/Header.scss';

import { isEmpty as _isEmpty } from 'lodash';
import classnames from 'classnames';
import LangSelectBox from '@atoms/DefaultSelectBox';
import LanguageBox from '@organisms/common/LanguageBox';
import { getPathName } from '@helpers/StringHelper';
import { useMobxStores } from '@stores/store';

const Header = () => {
  // style
  const [isMain, setIsMain] = useState(true);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const pathname = getPathName(location.pathname);
  const { mainStore } = useMobxStores();

  useEffect(() => {
    if (pathname !== '/' && pathname !== '/' + i18n.language) {
      setIsMain(false);
    } else {
      setIsMain(true);
    }
  }, [location]);

  return (
    <>
      {/* policy tw-bg-black */}
      <header
        className={`z-[90] relative ${
          isMain && isMobileWithOutIpad() ? 'main' : 'sub'
        }`}
      >
        <HeaderMobile />
        {/* policy tw-bg-white */}
        {/* <!-- desktop 버전 --> */}
        {/* policy tw-bg-black */}
        <div
          id="dt-menu-wrap"
          className={classnames('top-0 bg-white border-b border-[#f1f1f1]')}
        >
          <div className="dt-menu">
            <h1 className="logo">
              <a href="/">
                <img
                  src={`/img/v2/logo-350-${
                    ['kr', 'en', 'jp'].includes(i18n.language)
                      ? i18n.language
                      : 'kr'
                  }.png`}
                  className="w-auto"
                />
              </a>
            </h1>
            <nav id="gnb">
              <ul className={`${i18n.language}_li`}>
                {NAV_LIST.map((nav, idx) => {
                  return (
                    <li
                      key={`nav_${idx}`}
                      className={classnames({
                        active:
                          (isMain && mainStore.isActive && nav.nav == 'GAME') ||
                          pathname === `/${i18n.language}${nav.link}` ||
                          pathname.includes(nav.link),
                      })}
                    >
                      <div className="menu-wrap">
                        <Link
                          to={
                            !_isEmpty(nav.link)
                              ? `/${i18n.language}${nav.link}`
                              : '#'
                          }
                          style={{
                            cursor: !_isEmpty(nav.link) ? 'pointer' : 'initial',
                          }}
                        >
                          {t(nav.title)}
                        </Link>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </nav>
            <div className="right-menu">
              <LanguageBox />
            </div>
          </div>
        </div>
      </header>
      <div className="h-[var(--header-g-height)]" />
    </>
  );
};

export default observer(Header);
